import { render, staticRenderFns } from "./ArrowRightIcon.vue?vue&type=template&id=518b65b6"
import script from "./ArrowRightIcon.vue?vue&type=script&lang=ts"
export * from "./ArrowRightIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports